/** @format */

import {isObject} from 'helpers/miscHelpers';

import {formatValue} from './formatHelpers';

export const isEmpty = (value: Record<string, unknown> | string | null | undefined): boolean => {
  if (!value) return true;

  if (typeof value === 'string') {
    return value.trim() === '';
  }

  if (isObject(value)) {
    return Object.keys(value).length === 0;
  }

  return false;
};

export const prepareDisplayTexts = (
  valueBefore: Record<string, unknown> | null | undefined,
  valueAfter: Record<string, unknown> | null | undefined,
  isExpandable: boolean,
  isExpanded: boolean,
  maxLength: number,
) => {
  const fullBeforeText = valueBefore ? formatValue(valueBefore) : '';
  const fullAfterText = valueAfter ? formatValue(valueAfter) : '';

  const beforeText =
    isExpandable && !isExpanded ? fullBeforeText.slice(0, maxLength) + '...' : fullBeforeText;

  const afterText =
    isExpandable && !isExpanded ? fullAfterText.slice(0, maxLength) + '...' : fullAfterText;

  return {beforeText, afterText};
};
